<template>
  <div>
    <header class="pt-5 mb-32">
      <div class="container max-w-5xl mx-auto">
        <div class="flex flex-col sm:flex-row jusitfy-between items-center mb-2 md:mb-6 mt-2">
          <div class="w-6/6 sm:w-auto md:w-3/6 lg:w-2/6">
          <Logo alt="Post Office Credit Card QuickCheck" class="h-14 w-16 inline-block mr-5"></Logo>
            <span class="text-xl align-text-middle font-semibold">
              Credit Card QuickCheck
            </span>
          </div>
        </div>
      </div>
    </header>
    <div class="curved-container container max-w-5xl mx-auto px-8 pt-8">
      <h1 class="text-xl md:text-2xl text-center leading-none mb-6 mx-0 md:mx-8">
        Sorry! We are experiencing technical issues
      </h1>
      <h2 class="text-3xl md:text-5xl text-center leading-tight lg:leading-none font-semibold mb-6 mx-0 md:mx-8">
        Unable to complete your QuickCheck result at this time
      </h2>
      <div class="shadow-full mt-2 p-8 rounded-lg mb-10">
        <div class="text-center px-2 py-8 md:px-20 pb-10">
          <h2 class="text-xl md:text-2xl text-center leading-none mb-6 mx-0 md:mx-8">
            Please try again later
          </h2>
            <div class="flex justify-center">
              <button @click="returnToForm()" class="text-xl font-semibold px-10 w-full sm:w-1/3 hover:bg-polred-dark shadow bg-polred focus:shadow-outline focus:outline-none text-white py-2 px-4 rounded-full" type="button">
                Back to QuickCheck <RightArrowIcon class="h-3 fill-current inline"/>
              </button>
            </div>
          </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>

import '@/v2/assets/css/app.css'
import 'vue-loading-overlay/dist/vue-loading.css'
import Footer from '@/v2/components/Footer'

import Logo from '@/v2/assets/images/logos/post-office.svg'
import RightArrowIcon from '@/v2/assets/images/icons/right-arrow.svg'

export default {
  name: 'ErrorOccurred',
  components : {
    Logo,
    RightArrowIcon,
    Footer
  },
  methods: {
    returnToForm() {
      window.location = window.location.href.substr(0, window.location.href.indexOf('#'))
    }
  }
}
</script>